// Rides that ended with no Training Record (B6, Jill 2026-10-07).
//
// One copy of the rule for the portal (src/lib/ridesWithoutTr.js re-exports
// it). Plain JS, no imports, so tests/ridesWithoutTr.test.mjs can pin it.
// The weekly reminder email that also used it was deleted (Jill 2026-10-10);
// the card and red dot on Training Records stay.
//
// A ride is "without a TR" when it is still planned, its last day is before
// today, it is on or after the day TRs went live in the portal, and no
// tr_records row covers it, in ANY status (a draft counts: the trainee has
// started). A record covers a ride when it names the ride through
// training_trip_id, or it is the same trainee's and dated inside the ride.
// A ride the trainee already said needs no TR (completion_note) is never
// listed; callers select completion_note so that answer reaches the rule.

// The portal went live for TRs 2026-07-01; earlier rides have no TRs to show.
export const TR_GO_LIVE = "2026-07-01";

export function lastDay(trip) {
  return trip.end_date || trip.start_date || null;
}

// PostgREST `or` filter for "effective last day" (end_date, or start_date when
// end_date is null: single-day rides) within a range. Bounds are inclusive
// for `gte`/`lte` and exclusive for `lt`. Pass any of gte, lte, lt.
export function lastDayFilter({ gte, lte, lt } = {}) {
  const part = (col) => [
    gte ? `${col}.gte.${gte}` : null,
    lte ? `${col}.lte.${lte}` : null,
    lt ? `${col}.lt.${lt}` : null,
  ].filter(Boolean);
  return `and(${part("end_date").join(",")}),and(end_date.is.null,${part("start_date").join(",")})`;
}

function covers(trip, rec) {
  if (rec.training_trip_id && rec.training_trip_id === trip.id) return true;
  // a record that names a cargo job is cargo work, never a ride's, even when
  // its date falls inside one (Codex on #637)
  if (rec.cargo_event_id) return false;
  if (!rec.trainee_id || rec.trainee_id !== trip.trainee_id || !rec.record_date) return false;
  const first = trip.start_date || lastDay(trip);
  return rec.record_date >= first && rec.record_date <= lastDay(trip);
}

// The records that cover a ride, by the same rule: linked to it, or the
// same trainee's and dated inside it (the Approved rides card, Jill
// 2026-10-23; Codex on #610: a record made by hand counts too).
export function rideRecords(trip, records) {
  return (records || []).filter((r) => covers(trip, r));
}

export function ridesWithoutTr(trips, records, { today, since = TR_GO_LIVE } = {}) {
  if (!today) throw new Error("ridesWithoutTr needs today");
  return (trips || []).filter((t) => {
    if (t.status !== "planned") return false;
    // the trainee answered "No TRs for this ride" before it sailed (Jill
    // 2026-10-23): it stays planned for the calendar, but nobody asks again
    if (t.completion_note && String(t.completion_note).trim()) return false;
    const end = lastDay(t);
    if (!end || end >= today || end < since) return false;
    return !(records || []).some((r) => covers(t, r));
  });
}
